const DEFAULT_BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveMediaUrl(url, backendOrigin = DEFAULT_BACKEND_ORIGIN) {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;

  const normalizedOrigin = (backendOrigin || "").replace(/\/$/, "");
  if (url.startsWith("/")) {
    return normalizedOrigin ? `${normalizedOrigin}${url}` : url;
  }

  return url;
}
